import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "ListBoxes"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", { d: "M22.5 6H12V7.5H22.5V6zM22.5 16.5H12V18H22.5V16.5zM7.5 10.5H3C2.60232 10.4995 2.22105 10.3414 1.93984 10.0602 1.65864 9.77895 1.50046 9.39768 1.5 9V4.5C1.50046 4.10232 1.65864 3.72105 1.93984 3.43984 2.22105 3.15864 2.60232 3.00046 3 3H7.5C7.89768 3.00046 8.27895 3.15864 8.56016 3.43984 8.84136 3.72105 8.99954 4.10232 9 4.5V9C8.99954 9.39768 8.84136 9.77895 8.56016 10.0602 8.27895 10.3414 7.89768 10.4995 7.5 10.5zM3 4.5V9H7.5009L7.5 4.5H3zM7.5 21H3C2.60232 20.9995 2.22105 20.8414 1.93984 20.5602 1.65864 20.279 1.50046 19.8977 1.5 19.5V15C1.50046 14.6023 1.65864 14.221 1.93984 13.9398 2.22105 13.6586 2.60232 13.5005 3 13.5H7.5C7.89768 13.5005 8.27895 13.6586 8.56016 13.9398 8.84136 14.221 8.99954 14.6023 9 15V19.5C8.99954 19.8977 8.84136 20.279 8.56016 20.5602 8.27895 20.8414 7.89768 20.9995 7.5 21zM3 15V19.5H7.5009L7.5 15H3z" }, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/ListBoxes.vue"]]);
